//
import Model from "@/models/Model"

/**
* @description
* This class describes an acc bank card conciliation.
*
* @class AccBankCardConciliation (name)
*/
export default class AccBankCardConciliation extends Model {

  static includes = [
    'accounting_bank_card_movement_detail',
    'g_user',
    'accounting_bank_card_branch_office',
    'acc_accounting_seat',
  ]

  /**
   * @description
   * { property_description }
   *
   * @type       {<type>}
   */
  get accounting_seat_code() {
    return this.acc_accounting_seat ? this.acc_accounting_seat.code : '-'
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get amount_computed() {
    return this.deposit ? this.amount : this.charge > 0 ? this.amount * -1 : this.amount
  }

  /**
   * @description
   * { property_description }
   *
   * @type       {<type>}
   */
  get bank_card_movement_detail() {
    return this.accounting_bank_card_movement_detail ? this.accounting_bank_card_movement_detail.movement_detail : 'Sin movimiento'
  }

  /**
   * qdescription
   * { function_description }
   *
   * @return     {<type>}  { description_of_the_return_value }
   */
  get g_user_name_case() {
    return this.getProperty('g_user.hr_employee.name_case', '-')
  }
  
  /**
   * @description
   * { function_description }
   *
   * @return  {string}  { description_of_the_return_value }
   */
  resource() {
    return "acc_bank_card_chile_conciliation"
  }
}